export default __webpack_public_path__ + "ce37600efe0f4f6682a3d7e3c70de08f.png";